/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AcceptInvitationResponseDto,
  ActionableResponseDto,
  AgedReceivablesResponseDto,
  AgingResponseDto,
  AssignTagsDto,
  AttachInvoiceLineItemDto,
  BasSummaryResponseDto,
  BatchUpdateInvoiceLineItemsDto,
  BatchUpdateQuoteLineItemsDto,
  BillExpenseBodyDto,
  ClaimOnboardingCelebrationResponseDto,
  ClientDetailResponseDto,
  ClientReportResponseDto,
  ClientResponseDto,
  ClientStatsResponseDto,
  ClientsControllerAssignTagsParams,
  ClientsControllerDeleteClientParams,
  ClientsControllerFindClientParams,
  ClientsControllerGetClientStatsParams,
  ClientsControllerListClientsParams,
  ClientsControllerRemoveTagParams,
  ClientsControllerUpdateClientParams,
  ContactResponseDto,
  ContactsControllerCreateContactParams,
  ContactsControllerDeleteContactParams,
  ContactsControllerListContactsParams,
  ContactsControllerUpdateContactParams,
  ConvertQuoteDto,
  ConvertQuoteSplitDto,
  ConvertedQuoteResponseDto,
  ConvertedQuoteSplitResponseDto,
  CreateBusinessExpenseDto,
  CreateClientDto,
  CreateContactDto,
  CreateInvoiceDto,
  CreateLineItemDto,
  CreateQuoteDto,
  CreateQuoteLineItemDto,
  CreateReceiptBundleJobDto,
  CreateReceiptBundleJobResponseDto,
  CreateRecurringBusinessExpenseDto,
  CreateRecurringInvoiceDto,
  CreateRecurringReimbursementExpenseDto,
  CreateReimbursementExpenseDto,
  CreateReminderScheduleDto,
  CreateTagDto,
  CreateTermsTemplateDto,
  DataExportControllerExportAccountingInvoicesParams,
  DataImportControllerCommitImportParams,
  DataImportControllerDeleteImportParams,
  DataImportControllerDownloadTemplateParams,
  DataImportControllerGetImportParams,
  DataImportControllerRollbackImportParams,
  DevSettingsResponseDto,
  DuplicateInvoiceDto,
  ExpenseReceiptResponseDto,
  ExpenseReceiptUrlsResponseDto,
  ExpenseReportResponseDto,
  ExpenseResponseDto,
  ExpensesControllerAssignTagsParams,
  ExpensesControllerBillExpenseParams,
  ExpensesControllerDeleteExpenseParams,
  ExpensesControllerDeleteReceiptParams,
  ExpensesControllerDuplicateExpenseParams,
  ExpensesControllerFindExpenseParams,
  ExpensesControllerGetReceiptParams,
  ExpensesControllerListExpensesParams,
  ExpensesControllerRemoveTagParams,
  ExpensesControllerUpdateExpenseParams,
  ExpensesControllerUploadReceiptParams,
  ExportJobStatusResponseDto,
  FeatureToggleResponseDto,
  HealthResponseDto,
  ImportCommitResponseDto,
  ImportJobResponseDto,
  InvitationAcceptanceControllerAcceptParams,
  InvitationAcceptanceControllerGetPreviewParams,
  InvitationPreviewDto,
  InvoiceDetailResponseDto,
  InvoiceLineItemResponseDto,
  InvoiceLineItemsControllerAttachLineItemParams,
  InvoiceLineItemsControllerBatchUpdateLineItemsParams,
  InvoiceLineItemsControllerDeleteInvoiceLineItemParams,
  InvoiceLineItemsControllerListInvoiceLineItemsParams,
  InvoiceLineItemsControllerSyncAllInvoiceLineItemsParams,
  InvoiceLineItemsControllerSyncInvoiceLineItemParams,
  InvoiceLineItemsControllerUpdateInvoiceLineItemParams,
  InvoiceNumberAvailabilityResponseDto,
  InvoicePdfControllerGeneratePdfParams,
  InvoicePdfControllerGetLatestSignedUrlParams,
  InvoicePdfControllerGetVersionSignedUrlParams,
  InvoicePdfControllerListVersionsParams,
  InvoicePdfControllerPreviewTemplateParams,
  InvoicePdfSignedUrlResponseDto,
  InvoicePdfVersionResponseDto,
  InvoiceReminderResponseDto,
  InvoiceRemindersControllerListInvoiceRemindersParams,
  InvoiceRemindersControllerStopInvoiceRemindersParams,
  InvoiceRemindersControllerUpdateInvoiceReminderParams,
  InvoiceResponseDto,
  InvoiceSummaryResponseDto,
  InvoicesControllerArchiveInvoiceParams,
  InvoicesControllerAssignTagsParams,
  InvoicesControllerDeleteInvoiceParams,
  InvoicesControllerDeletePaymentParams,
  InvoicesControllerDeletePaymentReceiptParams,
  InvoicesControllerDuplicateInvoiceParams,
  InvoicesControllerGetInvoiceNumberAvailabilityParams,
  InvoicesControllerGetInvoiceParams,
  InvoicesControllerGetInvoicePreviewParams,
  InvoicesControllerGetPaymentReceiptParams,
  InvoicesControllerLinkReissuedInvoiceParams,
  InvoicesControllerListInvoicesParams,
  InvoicesControllerRecordPaymentParams,
  InvoicesControllerReissueInvoiceParams,
  InvoicesControllerRemoveTagParams,
  InvoicesControllerSendInvoiceParams,
  InvoicesControllerSendReminderEmailParams,
  InvoicesControllerSyncAllInvoiceLineItemsParams,
  InvoicesControllerTransitionInvoiceStatusParams,
  InvoicesControllerUnarchiveInvoiceParams,
  InvoicesControllerUnlinkReissuedInvoiceParams,
  InvoicesControllerUpdateInvoiceParams,
  InvoicesControllerUploadPaymentReceiptParams,
  LineItemReportResponseDto,
  LineItemResponseDto,
  LineItemSuggestionResponseDto,
  LineItemsControllerAssignTagsParams,
  LineItemsControllerDeleteLineItemParams,
  LineItemsControllerGetLineItemParams,
  LineItemsControllerListLineItemsParams,
  LineItemsControllerRemoveTagParams,
  LineItemsControllerSuggestLineItemsParams,
  LineItemsControllerUpdateLineItemParams,
  LinkReissuedInvoiceDto,
  MyIpResponseDto,
  NextInvoiceNumberResponseDto,
  NotificationPreferenceResponseDto,
  NotificationResponseDto,
  NotificationsControllerGetSummaryParams,
  NotificationsControllerListNotificationsParams,
  NotificationsControllerMarkReadParams,
  NotificationsControllerSnoozeParams,
  NotificationsSummaryResponseDto,
  OnboardingStatusResponseDto,
  OrganizationBrandingPreviewControllerRenderPreviewParams,
  OrganizationLogoResponseDto,
  OrganizationLogoSmallResponseDto,
  OrganizationResponseDto,
  PaymentReceiptResponseDto,
  PaymentReceiptUrlsResponseDto,
  PaymentResponseDto,
  ProfitAndLossResponseDto,
  PushSubscriptionResponseDto,
  PushSubscriptionsControllerRemoveParams,
  QuoteLineItemResponseDto,
  QuoteLineItemsControllerAddQuoteLineItemParams,
  QuoteLineItemsControllerBatchUpdateLineItemsParams,
  QuoteLineItemsControllerDeleteQuoteLineItemParams,
  QuoteLineItemsControllerListQuoteLineItemsParams,
  QuoteLineItemsControllerSyncQuoteLineItemParams,
  QuoteLineItemsControllerUpdateQuoteLineItemParams,
  QuotePdfControllerGeneratePdfParams,
  QuotePdfControllerGetLatestSignedUrlParams,
  QuotePdfControllerGetVersionSignedUrlParams,
  QuotePdfControllerListVersionsParams,
  QuotePdfControllerPreviewTemplateParams,
  QuotePdfSignedUrlResponseDto,
  QuotePdfVersionResponseDto,
  QuoteResponseDto,
  QuoteRevisionSummaryDto,
  QuotesControllerArchiveQuoteParams,
  QuotesControllerAssignTagsParams,
  QuotesControllerConvertParams,
  QuotesControllerConvertSplitParams,
  QuotesControllerDeleteQuoteParams,
  QuotesControllerGetQuoteParams,
  QuotesControllerGetQuotePreviewParams,
  QuotesControllerGetRevisionsParams,
  QuotesControllerListQuotesParams,
  QuotesControllerRemoveTagParams,
  QuotesControllerSendQuoteParams,
  QuotesControllerSupersedeParams,
  QuotesControllerUnarchiveQuoteParams,
  QuotesControllerUpdateQuoteParams,
  QuotesControllerUpdateStatusParams,
  ReceiptBundleEstimateResponseDto,
  RecordPaymentDto,
  RecurringExpenseResponseDto,
  RecurringExpensesControllerActivateParams,
  RecurringExpensesControllerCancelParams,
  RecurringExpensesControllerGetOneParams,
  RecurringExpensesControllerListParams,
  RecurringExpensesControllerListRunsParams,
  RecurringExpensesControllerPauseParams,
  RecurringExpensesControllerRemoveParams,
  RecurringExpensesControllerTriggerParams,
  RecurringExpensesControllerUpdateParams,
  RecurringInvoiceDetailResponseDto,
  RecurringInvoiceResponseDto,
  RecurringInvoicesControllerGetOneParams,
  RecurringInvoicesControllerListParams,
  RecurringInvoicesControllerRemoveParams,
  RecurringInvoicesControllerTriggerParams,
  RecurringInvoicesControllerUpdateParams,
  RecurringInvoicesControllerUpdateStatusParams,
  ReissueInvoiceDto,
  ReminderEmailPreviewResponseDto,
  ReminderScheduleLimitResponseDto,
  ReminderScheduleResponseDto,
  ReminderSchedulesControllerDeleteScheduleParams,
  ReminderSchedulesControllerGetScheduleParams,
  ReminderSchedulesControllerListSchedulesParams,
  ReminderSchedulesControllerPreviewReminderEmailParams,
  ReminderSchedulesControllerUpdateScheduleParams,
  ReportExportControllerExportReportParams,
  ReportPackControllerGetEofyPackParams,
  ReportPackControllerGetReceiptBundleEstimateParams,
  ReportPackControllerGetReceiptBundleJobParams,
  ReportsControllerGetAgedReceivablesParams,
  ReportsControllerGetAgingParams,
  ReportsControllerGetBasSummaryParams,
  ReportsControllerGetClientReportParams,
  ReportsControllerGetExpenseReportParams,
  ReportsControllerGetInvoiceSummaryParams,
  ReportsControllerGetLineItemReportParams,
  ReportsControllerGetProfitAndLossParams,
  ReportsControllerGetRevenueByTagParams,
  ReportsControllerGetRevenueTimelineParams,
  ReportsControllerGetTaxReportParams,
  RevenueTimelineResponseDto,
  RollbackResponseDto,
  SendInvoiceDto,
  SendInvoiceResponseDto,
  SendQuoteDto,
  SendQuoteResponseDto,
  SendReminderEmailDto,
  SendReminderEmailResponseDto,
  SetNextInvoiceNumberDto,
  StopInvoiceRemindersResponseDto,
  StripeConnectionResponseDto,
  StripeControllerGetPaymentUrlParams,
  StripeControllerListPaymentsParams,
  StripeOnboardingResponseDto,
  StripePaymentUrlResponseDto,
  StripeRefreshResponseDto,
  TagResponseDto,
  TagRevenueResponseDto,
  TagWithUsageResponseDto,
  TagsControllerDeleteTagParams,
  TagsControllerUpdateTagParams,
  TaxReportResponseDto,
  TenantMembershipResponseDto,
  TermsTemplateResponseDto,
  TermsTemplatesControllerDeleteTermsTemplateParams,
  TermsTemplatesControllerSetDefaultTermsTemplateParams,
  TermsTemplatesControllerUpdateTermsTemplateParams,
  TurnoverResponseDto,
  TwoFactorNudgePreferenceResponseDto,
  UnreadCountResponseDto,
  UpdateBusinessExpenseDto,
  UpdateClientDto,
  UpdateContactDto,
  UpdateInvoiceDto,
  UpdateInvoiceLineItemDto,
  UpdateInvoiceReminderDto,
  UpdateLineItemDto,
  UpdateOrganizationAccessDto,
  UpdateOrganizationBusinessDto,
  UpdateOrganizationInvoicingDto,
  UpdateOrganizationPaymentOptionsDto,
  UpdateOrganizationTaxDto,
  UpdateOrganizationTermsDto,
  UpdateQuoteDto,
  UpdateQuoteLineItemDto,
  UpdateQuoteStatusDto,
  UpdateRecurringBusinessExpenseDto,
  UpdateRecurringInvoiceDto,
  UpdateRecurringInvoiceStatusDto,
  UpdateRecurringReimbursementExpenseDto,
  UpdateReimbursementExpenseDto,
  UpdateReminderScheduleDto,
  UpdateTagDto,
  UpdateTermsTemplateDto,
  UserAvatarResponseDto,
  UserFeedbackResponseDto,
  UserInvitationResponseDto,
  UserResponseDto,
  UsersControllerCancelInvitationParams,
  UsersControllerDeactivateUserParams,
  UsersControllerListUsersParams,
  UsersControllerReactivateUserParams,
  UsersControllerResetPasswordParams,
  UsersControllerUpdateUserRoleParams,
  UsersSummaryResponseDto,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class Api<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags feature-flags
   * @name FeatureFlagsControllerGetFeatureFlags
   * @request GET:/api/feature-flags
   */
  featureFlagsControllerGetFeatureFlags = (params: RequestParams = {}) =>
    this.request<FeatureToggleResponseDto[], void>({
      path: `/api/feature-flags`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags auth
   * @name AuthControllerGetMyIp
   * @summary Return the caller IP address (no auth required)
   * @request GET:/api/auth/my-ip
   */
  authControllerGetMyIp = (params: RequestParams = {}) =>
    this.request<MyIpResponseDto, any>({
      path: `/api/auth/my-ip`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags clients
   * @name ClientsControllerListClients
   * @summary List clients
   * @request GET:/api/clients
   */
  clientsControllerListClients = (
    query: ClientsControllerListClientsParams = {},
    params: RequestParams = {},
  ) =>
    this.request<ClientResponseDto[], void>({
      path: `/api/clients`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags clients
   * @name ClientsControllerCreateClient
   * @summary Create a client
   * @request POST:/api/clients
   */
  clientsControllerCreateClient = (data: CreateClientDto, params: RequestParams = {}) =>
    this.request<ClientDetailResponseDto, void>({
      path: `/api/clients`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags clients
   * @name ClientsControllerGetClientStats
   * @summary Get a client's lifetime invoice/quote statistics
   * @request GET:/api/clients/{id}/stats
   */
  clientsControllerGetClientStats = (
    { id }: ClientsControllerGetClientStatsParams,
    params: RequestParams = {},
  ) =>
    this.request<ClientStatsResponseDto, void>({
      path: `/api/clients/${id}/stats`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags clients
   * @name ClientsControllerFindClient
   * @summary Get a client
   * @request GET:/api/clients/{id}
   */
  clientsControllerFindClient = (
    { id }: ClientsControllerFindClientParams,
    params: RequestParams = {},
  ) =>
    this.request<ClientDetailResponseDto, void>({
      path: `/api/clients/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags clients
   * @name ClientsControllerUpdateClient
   * @summary Update a client
   * @request PATCH:/api/clients/{id}
   */
  clientsControllerUpdateClient = (
    { id }: ClientsControllerUpdateClientParams,
    data: UpdateClientDto,
    params: RequestParams = {},
  ) =>
    this.request<ClientDetailResponseDto, void>({
      path: `/api/clients/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags clients
   * @name ClientsControllerDeleteClient
   * @summary Delete a client
   * @request DELETE:/api/clients/{id}
   */
  clientsControllerDeleteClient = (
    { id }: ClientsControllerDeleteClientParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/clients/${id}`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags clients
   * @name ClientsControllerAssignTags
   * @summary Assign tags to a client
   * @request POST:/api/clients/{id}/tags
   */
  clientsControllerAssignTags = (
    { id }: ClientsControllerAssignTagsParams,
    data: AssignTagsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/clients/${id}/tags`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })
  /**
   * No description
   *
   * @tags clients
   * @name ClientsControllerRemoveTag
   * @summary Remove a tag from a client
   * @request DELETE:/api/clients/{id}/tags/{tagId}
   */
  clientsControllerRemoveTag = (
    { tagId, id }: ClientsControllerRemoveTagParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/clients/${id}/tags/${tagId}`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags contacts
   * @name ContactsControllerListContacts
   * @summary List contacts for a client
   * @request GET:/api/clients/{clientId}/contacts
   */
  contactsControllerListContacts = (
    { clientId }: ContactsControllerListContactsParams,
    params: RequestParams = {},
  ) =>
    this.request<ContactResponseDto[], void>({
      path: `/api/clients/${clientId}/contacts`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags contacts
   * @name ContactsControllerCreateContact
   * @summary Create a contact for a client
   * @request POST:/api/clients/{clientId}/contacts
   */
  contactsControllerCreateContact = (
    { clientId }: ContactsControllerCreateContactParams,
    data: CreateContactDto,
    params: RequestParams = {},
  ) =>
    this.request<ContactResponseDto, void>({
      path: `/api/clients/${clientId}/contacts`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags contacts
   * @name ContactsControllerUpdateContact
   * @summary Update a contact
   * @request PATCH:/api/clients/{clientId}/contacts/{id}
   */
  contactsControllerUpdateContact = (
    { id, clientId }: ContactsControllerUpdateContactParams,
    data: UpdateContactDto,
    params: RequestParams = {},
  ) =>
    this.request<ContactResponseDto, void>({
      path: `/api/clients/${clientId}/contacts/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags contacts
   * @name ContactsControllerDeleteContact
   * @summary Delete a contact
   * @request DELETE:/api/clients/{clientId}/contacts/{id}
   */
  contactsControllerDeleteContact = (
    { id, clientId }: ContactsControllerDeleteContactParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/clients/${clientId}/contacts/${id}`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerListExpenses
   * @summary List expenses
   * @request GET:/api/expenses
   */
  expensesControllerListExpenses = (
    query: ExpensesControllerListExpensesParams = {},
    params: RequestParams = {},
  ) =>
    this.request<ExpenseResponseDto[], void>({
      path: `/api/expenses`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerFindExpense
   * @summary Get an expense
   * @request GET:/api/expenses/{id}
   */
  expensesControllerFindExpense = (
    { id }: ExpensesControllerFindExpenseParams,
    params: RequestParams = {},
  ) =>
    this.request<ExpenseResponseDto, void>({
      path: `/api/expenses/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerUpdateExpense
   * @summary Update an expense
   * @request PATCH:/api/expenses/{id}
   */
  expensesControllerUpdateExpense = (
    { id }: ExpensesControllerUpdateExpenseParams,
    data: UpdateBusinessExpenseDto | UpdateReimbursementExpenseDto,
    params: RequestParams = {},
  ) =>
    this.request<ExpenseResponseDto, void>({
      path: `/api/expenses/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerDeleteExpense
   * @summary Delete an expense
   * @request DELETE:/api/expenses/{id}
   */
  expensesControllerDeleteExpense = (
    { id }: ExpensesControllerDeleteExpenseParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/expenses/${id}`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerCreateBusinessExpense
   * @summary Create a business expense
   * @request POST:/api/expenses/business
   */
  expensesControllerCreateBusinessExpense = (
    data: CreateBusinessExpenseDto,
    params: RequestParams = {},
  ) =>
    this.request<ExpenseResponseDto, void>({
      path: `/api/expenses/business`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerCreateReimbursementExpense
   * @summary Create a client reimbursement expense
   * @request POST:/api/expenses/reimbursement
   */
  expensesControllerCreateReimbursementExpense = (
    data: CreateReimbursementExpenseDto,
    params: RequestParams = {},
  ) =>
    this.request<ExpenseResponseDto, void>({
      path: `/api/expenses/reimbursement`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerDuplicateExpense
   * @summary Duplicate an expense as a new entry
   * @request POST:/api/expenses/{id}/duplicate
   */
  expensesControllerDuplicateExpense = (
    { id }: ExpensesControllerDuplicateExpenseParams,
    params: RequestParams = {},
  ) =>
    this.request<ExpenseResponseDto, void>({
      path: `/api/expenses/${id}/duplicate`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerAssignTags
   * @summary Assign tags to an expense
   * @request POST:/api/expenses/{id}/tags
   */
  expensesControllerAssignTags = (
    { id }: ExpensesControllerAssignTagsParams,
    data: AssignTagsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/expenses/${id}/tags`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerRemoveTag
   * @summary Remove a tag from an expense
   * @request DELETE:/api/expenses/{id}/tags/{tagId}
   */
  expensesControllerRemoveTag = (
    { tagId, id }: ExpensesControllerRemoveTagParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/expenses/${id}/tags/${tagId}`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerBillExpense
   * @summary Add a reimbursement expense to a draft invoice as a line item
   * @request POST:/api/expenses/{id}/bill
   */
  expensesControllerBillExpense = (
    { id }: ExpensesControllerBillExpenseParams,
    data: BillExpenseBodyDto,
    params: RequestParams = {},
  ) =>
    this.request<ExpenseResponseDto, void>({
      path: `/api/expenses/${id}/bill`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerUploadReceipt
   * @summary Upload or replace the receipt for an expense
   * @request POST:/api/expenses/{id}/receipt
   */
  expensesControllerUploadReceipt = (
    { id }: ExpensesControllerUploadReceiptParams,
    params: RequestParams = {},
  ) =>
    this.request<ExpenseReceiptResponseDto, void>({
      path: `/api/expenses/${id}/receipt`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerGetReceipt
   * @summary Get signed download URLs for the receipt
   * @request GET:/api/expenses/{id}/receipt
   */
  expensesControllerGetReceipt = (
    { id }: ExpensesControllerGetReceiptParams,
    params: RequestParams = {},
  ) =>
    this.request<ExpenseReceiptUrlsResponseDto, void>({
      path: `/api/expenses/${id}/receipt`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags expenses
   * @name ExpensesControllerDeleteReceipt
   * @summary Delete the receipt for an expense
   * @request DELETE:/api/expenses/{id}/receipt
   */
  expensesControllerDeleteReceipt = (
    { id }: ExpensesControllerDeleteReceiptParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/expenses/${id}/receipt`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Export
   * @name DataExportControllerExportClients
   * @summary Export clients as CSV
   * @request GET:/api/exports/clients
   */
  dataExportControllerExportClients = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/exports/clients`,
      method: 'GET',
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Export
   * @name DataExportControllerExportLineItems
   * @summary Export all line items as CSV
   * @request GET:/api/exports/line-items
   */
  dataExportControllerExportLineItems = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/exports/line-items`,
      method: 'GET',
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Export
   * @name DataExportControllerExportInvoices
   * @summary Export invoices as CSV
   * @request GET:/api/exports/invoices
   */
  dataExportControllerExportInvoices = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/exports/invoices`,
      method: 'GET',
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Export
   * @name DataExportControllerExportQuotes
   * @summary Export quotes as CSV
   * @request GET:/api/exports/quotes
   */
  dataExportControllerExportQuotes = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/exports/quotes`,
      method: 'GET',
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Export
   * @name DataExportControllerExportAccountingInvoices
   * @summary Export invoices as a Xero- or MYOB-compatible sales file
   * @request GET:/api/exports/accounting/invoices
   */
  dataExportControllerExportAccountingInvoices = (
    query: DataExportControllerExportAccountingInvoicesParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/exports/accounting/invoices`,
      method: 'GET',
      query: query,
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Export
   * @name DataExportControllerExportExpenses
   * @summary Export expenses as CSV
   * @request GET:/api/exports/expenses
   */
  dataExportControllerExportExpenses = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/exports/expenses`,
      method: 'GET',
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Import
   * @name DataImportControllerDownloadTemplate
   * @summary Download a sample CSV template for import
   * @request GET:/api/imports/templates/{type}
   */
  dataImportControllerDownloadTemplate = (
    { type }: DataImportControllerDownloadTemplateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/imports/templates/${type}`,
      method: 'GET',
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Import
   * @name DataImportControllerUploadCsv
   * @summary Upload CSV file for import
   * @request POST:/api/imports/upload
   */
  dataImportControllerUploadCsv = (params: RequestParams = {}) =>
    this.request<ImportJobResponseDto, void>({
      path: `/api/imports/upload`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Import
   * @name DataImportControllerCommitImport
   * @summary Commit a validated import job
   * @request POST:/api/imports/{id}/commit
   */
  dataImportControllerCommitImport = (
    { id }: DataImportControllerCommitImportParams,
    params: RequestParams = {},
  ) =>
    this.request<ImportCommitResponseDto, void>({
      path: `/api/imports/${id}/commit`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Import
   * @name DataImportControllerListImports
   * @summary List import jobs
   * @request GET:/api/imports
   */
  dataImportControllerListImports = (params: RequestParams = {}) =>
    this.request<ImportJobResponseDto[], void>({
      path: `/api/imports`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Import
   * @name DataImportControllerGetImport
   * @summary Get import job details
   * @request GET:/api/imports/{id}
   */
  dataImportControllerGetImport = (
    { id }: DataImportControllerGetImportParams,
    params: RequestParams = {},
  ) =>
    this.request<ImportJobResponseDto, void>({
      path: `/api/imports/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Import
   * @name DataImportControllerDeleteImport
   * @summary Delete a pending or validated import job
   * @request DELETE:/api/imports/{id}
   */
  dataImportControllerDeleteImport = (
    { id }: DataImportControllerDeleteImportParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/imports/${id}`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags Data Import
   * @name DataImportControllerRollbackImport
   * @summary Rollback a committed import
   * @request POST:/api/imports/{id}/rollback
   */
  dataImportControllerRollbackImport = (
    { id }: DataImportControllerRollbackImportParams,
    params: RequestParams = {},
  ) =>
    this.request<RollbackResponseDto, void>({
      path: `/api/imports/${id}/rollback`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerListInvoices
   * @summary List invoices
   * @request GET:/api/invoices
   * @secure
   */
  invoicesControllerListInvoices = (
    query: InvoicesControllerListInvoicesParams = {},
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponseDto[], void>({
      path: `/api/invoices`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerCreateInvoice
   * @summary Create invoice
   * @request POST:/api/invoices
   * @secure
   */
  invoicesControllerCreateInvoice = (
    data: CreateInvoiceDto,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponseDto, void>({
      path: `/api/invoices`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerGetNextInvoiceNumber
   * @summary Preview the next system-generated invoice number, without consuming it
   * @request GET:/api/invoices/next-number
   * @secure
   */
  invoicesControllerGetNextInvoiceNumber = (params: RequestParams = {}) =>
    this.request<NextInvoiceNumberResponseDto, void>({
      path: `/api/invoices/next-number`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerGetInvoiceNumberAvailability
   * @summary Check whether an invoice number is available
   * @request GET:/api/invoices/number-availability
   * @secure
   */
  invoicesControllerGetInvoiceNumberAvailability = (
    query: InvoicesControllerGetInvoiceNumberAvailabilityParams,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceNumberAvailabilityResponseDto, void>({
      path: `/api/invoices/number-availability`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerGetInvoice
   * @summary Get invoice with line items
   * @request GET:/api/invoices/{id}
   * @secure
   */
  invoicesControllerGetInvoice = (
    { id }: InvoicesControllerGetInvoiceParams,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceDetailResponseDto, void>({
      path: `/api/invoices/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerUpdateInvoice
   * @summary Update invoice
   * @request PATCH:/api/invoices/{id}
   * @secure
   */
  invoicesControllerUpdateInvoice = (
    { id }: InvoicesControllerUpdateInvoiceParams,
    data: UpdateInvoiceDto,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponseDto, void>({
      path: `/api/invoices/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerDeleteInvoice
   * @summary Delete invoice
   * @request DELETE:/api/invoices/{id}
   * @secure
   */
  invoicesControllerDeleteInvoice = (
    { id }: InvoicesControllerDeleteInvoiceParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/invoices/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerGetInvoicePreview
   * @summary Render invoice as HTML preview
   * @request GET:/api/invoices/{id}/preview
   * @secure
   */
  invoicesControllerGetInvoicePreview = (
    { id }: InvoicesControllerGetInvoicePreviewParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/invoices/${id}/preview`,
      method: 'GET',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerTransitionInvoiceStatus
   * @summary Transition invoice status
   * @request PATCH:/api/invoices/{id}/status
   * @secure
   */
  invoicesControllerTransitionInvoiceStatus = (
    { id }: InvoicesControllerTransitionInvoiceStatusParams,
    data: {
      status: 'DRAFT' | 'SENT' | 'PAID' | 'OVERDUE' | 'CANCELLED' | 'VOID'
    },
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponseDto, void>({
      path: `/api/invoices/${id}/status`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerArchiveInvoice
   * @summary Archive an invoice
   * @request POST:/api/invoices/{id}/archive
   * @secure
   */
  invoicesControllerArchiveInvoice = (
    { id }: InvoicesControllerArchiveInvoiceParams,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponseDto, void>({
      path: `/api/invoices/${id}/archive`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerUnarchiveInvoice
   * @summary Unarchive an invoice
   * @request POST:/api/invoices/{id}/unarchive
   * @secure
   */
  invoicesControllerUnarchiveInvoice = (
    { id }: InvoicesControllerUnarchiveInvoiceParams,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponseDto, void>({
      path: `/api/invoices/${id}/unarchive`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerSyncAllInvoiceLineItems
   * @summary Sync all line items on an invoice to their registry values
   * @request POST:/api/invoices/{id}/sync
   * @secure
   */
  invoicesControllerSyncAllInvoiceLineItems = (
    { id }: InvoicesControllerSyncAllInvoiceLineItemsParams,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceLineItemResponseDto[], void>({
      path: `/api/invoices/${id}/sync`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerSendInvoice
   * @summary Send an invoice to the client via email
   * @request POST:/api/invoices/{id}/send
   * @secure
   */
  invoicesControllerSendInvoice = (
    { id }: InvoicesControllerSendInvoiceParams,
    data: SendInvoiceDto,
    params: RequestParams = {},
  ) =>
    this.request<SendInvoiceResponseDto, void>({
      path: `/api/invoices/${id}/send`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerSendReminderEmail
   * @summary Send a payment reminder email to the client
   * @request POST:/api/invoices/{id}/reminder-email
   * @secure
   */
  invoicesControllerSendReminderEmail = (
    { id }: InvoicesControllerSendReminderEmailParams,
    data: SendReminderEmailDto,
    params: RequestParams = {},
  ) =>
    this.request<SendReminderEmailResponseDto, void>({
      path: `/api/invoices/${id}/reminder-email`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerDuplicateInvoice
   * @summary Duplicate an invoice as a new DRAFT
   * @request POST:/api/invoices/{id}/duplicate
   * @secure
   */
  invoicesControllerDuplicateInvoice = (
    { id }: InvoicesControllerDuplicateInvoiceParams,
    data?: DuplicateInvoiceDto,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponseDto, void>({
      path: `/api/invoices/${id}/duplicate`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * Cancels the original when it is OVERDUE and creates a DRAFT copy with new dates,
   * linked back to the original.
   *
   * @tags invoices
   * @name InvoicesControllerReissueInvoice
   * @summary Re-issue an OVERDUE or CANCELLED invoice as a new DRAFT
   * @request POST:/api/invoices/{id}/reissue
   * @secure
   */
  invoicesControllerReissueInvoice = (
    { id }: InvoicesControllerReissueInvoiceParams,
    data?: ReissueInvoiceDto,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponseDto, void>({
      path: `/api/invoices/${id}/reissue`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * Records the re-issue relationship after the fact. Changes no statuses, dates,
   * reminders or expenses.
   *
   * @tags invoices
   * @name InvoicesControllerLinkReissuedInvoice
   * @summary Link a CANCELLED invoice to the existing invoice that replaced it
   * @request PUT:/api/invoices/{id}/reissued-as
   * @secure
   */
  invoicesControllerLinkReissuedInvoice = (
    { id }: InvoicesControllerLinkReissuedInvoiceParams,
    data: LinkReissuedInvoiceDto,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceDetailResponseDto, void>({
      path: `/api/invoices/${id}/reissued-as`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerUnlinkReissuedInvoice
   * @summary Remove the re-issue link between an invoice and its replacement
   * @request DELETE:/api/invoices/{id}/reissued-as
   * @secure
   */
  invoicesControllerUnlinkReissuedInvoice = (
    { id }: InvoicesControllerUnlinkReissuedInvoiceParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/invoices/${id}/reissued-as`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerAssignTags
   * @summary Assign tags to an invoice
   * @request POST:/api/invoices/{id}/tags
   * @secure
   */
  invoicesControllerAssignTags = (
    { id }: InvoicesControllerAssignTagsParams,
    data: AssignTagsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/invoices/${id}/tags`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerRemoveTag
   * @summary Remove a tag from an invoice
   * @request DELETE:/api/invoices/{id}/tags/{tagId}
   * @secure
   */
  invoicesControllerRemoveTag = (
    { tagId, id }: InvoicesControllerRemoveTagParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/invoices/${id}/tags/${tagId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerRecordPayment
   * @summary Record a manual (non-Stripe) payment against an invoice
   * @request POST:/api/invoices/{id}/payments
   * @secure
   */
  invoicesControllerRecordPayment = (
    { id }: InvoicesControllerRecordPaymentParams,
    data: RecordPaymentDto,
    params: RequestParams = {},
  ) =>
    this.request<PaymentResponseDto, void>({
      path: `/api/invoices/${id}/payments`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerDeletePayment
   * @summary Delete a manual payment, reverting the invoice from PAID if it was covering the total
   * @request DELETE:/api/invoices/{id}/payments/{paymentId}
   * @secure
   */
  invoicesControllerDeletePayment = (
    { paymentId, id }: InvoicesControllerDeletePaymentParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/invoices/${id}/payments/${paymentId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerUploadPaymentReceipt
   * @summary Upload or replace the receipt for a manual payment
   * @request POST:/api/invoices/{id}/payments/{paymentId}/receipt
   * @secure
   */
  invoicesControllerUploadPaymentReceipt = (
    { paymentId, id }: InvoicesControllerUploadPaymentReceiptParams,
    params: RequestParams = {},
  ) =>
    this.request<PaymentReceiptResponseDto, void>({
      path: `/api/invoices/${id}/payments/${paymentId}/receipt`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerGetPaymentReceipt
   * @summary Get signed download URLs for a payment receipt
   * @request GET:/api/invoices/{id}/payments/{paymentId}/receipt
   * @secure
   */
  invoicesControllerGetPaymentReceipt = (
    { paymentId, id }: InvoicesControllerGetPaymentReceiptParams,
    params: RequestParams = {},
  ) =>
    this.request<PaymentReceiptUrlsResponseDto, void>({
      path: `/api/invoices/${id}/payments/${paymentId}/receipt`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoices
   * @name InvoicesControllerDeletePaymentReceipt
   * @summary Delete the receipt for a manual payment
   * @request DELETE:/api/invoices/{id}/payments/{paymentId}/receipt
   * @secure
   */
  invoicesControllerDeletePaymentReceipt = (
    { paymentId, id }: InvoicesControllerDeletePaymentReceiptParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/invoices/${id}/payments/${paymentId}/receipt`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-line-items
   * @name InvoiceLineItemsControllerListInvoiceLineItems
   * @summary List line items on an invoice
   * @request GET:/api/invoices/{invoiceId}/line-items
   * @secure
   */
  invoiceLineItemsControllerListInvoiceLineItems = (
    { invoiceId }: InvoiceLineItemsControllerListInvoiceLineItemsParams,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceLineItemResponseDto[], void>({
      path: `/api/invoices/${invoiceId}/line-items`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-line-items
   * @name InvoiceLineItemsControllerBatchUpdateLineItems
   * @summary Batch update all line items on an invoice
   * @request PUT:/api/invoices/{invoiceId}/line-items
   * @secure
   */
  invoiceLineItemsControllerBatchUpdateLineItems = (
    { invoiceId }: InvoiceLineItemsControllerBatchUpdateLineItemsParams,
    data: BatchUpdateInvoiceLineItemsDto,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceLineItemResponseDto[], void>({
      path: `/api/invoices/${invoiceId}/line-items`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-line-items
   * @name InvoiceLineItemsControllerAttachLineItem
   * @summary Attach a registry line item to an invoice
   * @request POST:/api/invoices/{invoiceId}/line-items
   * @secure
   */
  invoiceLineItemsControllerAttachLineItem = (
    { invoiceId }: InvoiceLineItemsControllerAttachLineItemParams,
    data: AttachInvoiceLineItemDto,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceLineItemResponseDto, void>({
      path: `/api/invoices/${invoiceId}/line-items`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-line-items
   * @name InvoiceLineItemsControllerSyncAllInvoiceLineItems
   * @summary Sync all non-detached line items on an invoice to their registry values
   * @request POST:/api/invoices/{invoiceId}/line-items/sync
   * @secure
   */
  invoiceLineItemsControllerSyncAllInvoiceLineItems = (
    { invoiceId }: InvoiceLineItemsControllerSyncAllInvoiceLineItemsParams,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceLineItemResponseDto[], void>({
      path: `/api/invoices/${invoiceId}/line-items/sync`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-line-items
   * @name InvoiceLineItemsControllerSyncInvoiceLineItem
   * @summary Sync one line item back to its registry values
   * @request POST:/api/invoices/{invoiceId}/line-items/{id}/sync
   * @secure
   */
  invoiceLineItemsControllerSyncInvoiceLineItem = (
    { id, invoiceId }: InvoiceLineItemsControllerSyncInvoiceLineItemParams,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceLineItemResponseDto, void>({
      path: `/api/invoices/${invoiceId}/line-items/${id}/sync`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-line-items
   * @name InvoiceLineItemsControllerUpdateInvoiceLineItem
   * @summary Edit an invoice line item (detaches it from the registry)
   * @request PATCH:/api/invoices/{invoiceId}/line-items/{id}
   * @secure
   */
  invoiceLineItemsControllerUpdateInvoiceLineItem = (
    { id, invoiceId }: InvoiceLineItemsControllerUpdateInvoiceLineItemParams,
    data: UpdateInvoiceLineItemDto,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceLineItemResponseDto, void>({
      path: `/api/invoices/${invoiceId}/line-items/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-line-items
   * @name InvoiceLineItemsControllerDeleteInvoiceLineItem
   * @summary Remove a line item from an invoice
   * @request DELETE:/api/invoices/{invoiceId}/line-items/{id}
   * @secure
   */
  invoiceLineItemsControllerDeleteInvoiceLineItem = (
    { id, invoiceId }: InvoiceLineItemsControllerDeleteInvoiceLineItemParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/invoices/${invoiceId}/line-items/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-pdf
   * @name InvoicePdfControllerGeneratePdf
   * @summary Generate a new PDF version for an invoice
   * @request POST:/api/invoices/{invoiceId}/pdf
   * @secure
   */
  invoicePdfControllerGeneratePdf = (
    { invoiceId }: InvoicePdfControllerGeneratePdfParams,
    params: RequestParams = {},
  ) =>
    this.request<InvoicePdfVersionResponseDto, void>({
      path: `/api/invoices/${invoiceId}/pdf`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-pdf
   * @name InvoicePdfControllerListVersions
   * @summary List all PDF versions for an invoice
   * @request GET:/api/invoices/{invoiceId}/pdf/versions
   * @secure
   */
  invoicePdfControllerListVersions = (
    { invoiceId }: InvoicePdfControllerListVersionsParams,
    params: RequestParams = {},
  ) =>
    this.request<InvoicePdfVersionResponseDto[], void>({
      path: `/api/invoices/${invoiceId}/pdf/versions`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-pdf
   * @name InvoicePdfControllerGetVersionSignedUrl
   * @summary Get a signed URL for a specific PDF version
   * @request GET:/api/invoices/{invoiceId}/pdf/versions/{versionId}
   * @secure
   */
  invoicePdfControllerGetVersionSignedUrl = (
    { versionId, invoiceId }: InvoicePdfControllerGetVersionSignedUrlParams,
    params: RequestParams = {},
  ) =>
    this.request<InvoicePdfSignedUrlResponseDto, void>({
      path: `/api/invoices/${invoiceId}/pdf/versions/${versionId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-pdf
   * @name InvoicePdfControllerGetLatestSignedUrl
   * @summary Get a signed URL for the latest PDF version
   * @request GET:/api/invoices/{invoiceId}/pdf/latest
   * @secure
   */
  invoicePdfControllerGetLatestSignedUrl = (
    { invoiceId }: InvoicePdfControllerGetLatestSignedUrlParams,
    params: RequestParams = {},
  ) =>
    this.request<InvoicePdfSignedUrlResponseDto, void>({
      path: `/api/invoices/${invoiceId}/pdf/latest`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-pdf
   * @name InvoicePdfControllerPreviewTemplate
   * @summary Preview the invoice template as HTML (dev only)
   * @request GET:/api/invoices/{invoiceId}/pdf/preview
   * @secure
   */
  invoicePdfControllerPreviewTemplate = (
    { invoiceId }: InvoicePdfControllerPreviewTemplateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/invoices/${invoiceId}/pdf/preview`,
      method: 'GET',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerGetOrganization
   * @summary Get organization settings
   * @request GET:/api/organization
   */
  organizationControllerGetOrganization = (params: RequestParams = {}) =>
    this.request<OrganizationResponseDto, void>({
      path: `/api/organization`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerUpdateBusiness
   * @summary Update business details
   * @request PATCH:/api/organization/business
   */
  organizationControllerUpdateBusiness = (
    data: UpdateOrganizationBusinessDto,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationResponseDto, void>({
      path: `/api/organization/business`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerAcceptTerms
   * @summary Accept the onboarding wizard Terms of Service
   * @request PATCH:/api/organization/terms
   */
  organizationControllerAcceptTerms = (
    data: UpdateOrganizationTermsDto,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationResponseDto, void>({
      path: `/api/organization/terms`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerUpdateTax
   * @summary Update tax & legal information
   * @request PATCH:/api/organization/tax
   */
  organizationControllerUpdateTax = (
    data: UpdateOrganizationTaxDto,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationResponseDto, void>({
      path: `/api/organization/tax`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerUpdatePaymentOptions
   * @summary Replace payment options array
   * @request PATCH:/api/organization/payment-options
   */
  organizationControllerUpdatePaymentOptions = (
    data: UpdateOrganizationPaymentOptionsDto,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationResponseDto, void>({
      path: `/api/organization/payment-options`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerUpdateInvoicing
   * @summary Update the invoice number prefix
   * @request PATCH:/api/organization/invoicing
   */
  organizationControllerUpdateInvoicing = (
    data: UpdateOrganizationInvoicingDto,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationResponseDto, void>({
      path: `/api/organization/invoicing`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerSetNextInvoiceNumber
   * @summary Bump the tenant's next invoice number
   * @request POST:/api/organization/invoicing/next-number
   */
  organizationControllerSetNextInvoiceNumber = (
    data: SetNextInvoiceNumberDto,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationResponseDto, void>({
      path: `/api/organization/invoicing/next-number`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerClaimOnboardingCelebration
   * @summary Idempotently claim the one-time onboarding celebration
   * @request POST:/api/organization/onboarding-celebration/claim
   */
  organizationControllerClaimOnboardingCelebration = (params: RequestParams = {}) =>
    this.request<ClaimOnboardingCelebrationResponseDto, void>({
      path: `/api/organization/onboarding-celebration/claim`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerUpdateAccess
   * @summary Update IP and domain access settings
   * @request PATCH:/api/organization/access
   */
  organizationControllerUpdateAccess = (
    data: UpdateOrganizationAccessDto,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationResponseDto, void>({
      path: `/api/organization/access`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerUploadLogo
   * @summary Upload or replace organization logo
   * @request POST:/api/organization/branding/logo
   */
  organizationControllerUploadLogo = (params: RequestParams = {}) =>
    this.request<OrganizationLogoResponseDto, void>({
      path: `/api/organization/branding/logo`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerDeleteLogo
   * @summary Remove organization logo
   * @request DELETE:/api/organization/branding/logo
   */
  organizationControllerDeleteLogo = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/organization/branding/logo`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerUploadLogoSmall
   * @summary Upload or replace organization small logo
   * @request POST:/api/organization/branding/logo-small
   */
  organizationControllerUploadLogoSmall = (params: RequestParams = {}) =>
    this.request<OrganizationLogoSmallResponseDto, void>({
      path: `/api/organization/branding/logo-small`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationControllerDeleteLogoSmall
   * @summary Remove organization small logo
   * @request DELETE:/api/organization/branding/logo-small
   */
  organizationControllerDeleteLogoSmall = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/organization/branding/logo-small`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags organization
   * @name OrganizationBrandingPreviewControllerRenderPreview
   * @summary Render a sample invoice/quote PDF or email as HTML, using the pending (unsaved) or saved logo
   * @request POST:/api/organization/branding/preview/{type}
   */
  organizationBrandingPreviewControllerRenderPreview = (
    { type }: OrganizationBrandingPreviewControllerRenderPreviewParams,
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/api/organization/branding/preview/${type}`,
      method: 'POST',
      ...params,
    })
  /**
   * No description
   *
   * @tags reminder-schedules
   * @name ReminderSchedulesControllerListSchedules
   * @summary List global reminder schedules, or every client-owned schedule
   * @request GET:/api/reminder-schedules
   */
  reminderSchedulesControllerListSchedules = (
    query: ReminderSchedulesControllerListSchedulesParams = {},
    params: RequestParams = {},
  ) =>
    this.request<ReminderScheduleResponseDto[], void>({
      path: `/api/reminder-schedules`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reminder-schedules
   * @name ReminderSchedulesControllerCreateSchedule
   * @summary Create a reminder schedule
   * @request POST:/api/reminder-schedules
   */
  reminderSchedulesControllerCreateSchedule = (
    data: CreateReminderScheduleDto,
    params: RequestParams = {},
  ) =>
    this.request<ReminderScheduleResponseDto, void>({
      path: `/api/reminder-schedules`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reminder-schedules
   * @name ReminderSchedulesControllerGetDefaultSchedule
   * @summary Get the default reminder schedule
   * @request GET:/api/reminder-schedules/default
   */
  reminderSchedulesControllerGetDefaultSchedule = (params: RequestParams = {}) =>
    this.request<ReminderScheduleResponseDto, void>({
      path: `/api/reminder-schedules/default`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reminder-schedules
   * @name ReminderSchedulesControllerGetScheduleLimit
   * @summary Get the organisation's cap on reminder schedules and how many it has
   * @request GET:/api/reminder-schedules/limit
   */
  reminderSchedulesControllerGetScheduleLimit = (params: RequestParams = {}) =>
    this.request<ReminderScheduleLimitResponseDto, void>({
      path: `/api/reminder-schedules/limit`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reminder-schedules
   * @name ReminderSchedulesControllerPreviewReminderEmail
   * @summary Preview the standard reminder email for a stage, rendered with sample data
   * @request GET:/api/reminder-schedules/email-preview
   */
  reminderSchedulesControllerPreviewReminderEmail = (
    query: ReminderSchedulesControllerPreviewReminderEmailParams,
    params: RequestParams = {},
  ) =>
    this.request<ReminderEmailPreviewResponseDto, void>({
      path: `/api/reminder-schedules/email-preview`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reminder-schedules
   * @name ReminderSchedulesControllerGetSchedule
   * @summary Get a reminder schedule
   * @request GET:/api/reminder-schedules/{id}
   */
  reminderSchedulesControllerGetSchedule = (
    { id }: ReminderSchedulesControllerGetScheduleParams,
    params: RequestParams = {},
  ) =>
    this.request<ReminderScheduleResponseDto, void>({
      path: `/api/reminder-schedules/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reminder-schedules
   * @name ReminderSchedulesControllerUpdateSchedule
   * @summary Update a reminder schedule
   * @request PATCH:/api/reminder-schedules/{id}
   */
  reminderSchedulesControllerUpdateSchedule = (
    { id }: ReminderSchedulesControllerUpdateScheduleParams,
    data: UpdateReminderScheduleDto,
    params: RequestParams = {},
  ) =>
    this.request<ReminderScheduleResponseDto, void>({
      path: `/api/reminder-schedules/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reminder-schedules
   * @name ReminderSchedulesControllerDeleteSchedule
   * @summary Delete a reminder schedule
   * @request DELETE:/api/reminder-schedules/{id}
   */
  reminderSchedulesControllerDeleteSchedule = (
    { id }: ReminderSchedulesControllerDeleteScheduleParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/reminder-schedules/${id}`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-reminders
   * @name InvoiceRemindersControllerListInvoiceReminders
   * @summary List invoice reminders with their invoice and client summary
   * @request GET:/api/invoice-reminders
   */
  invoiceRemindersControllerListInvoiceReminders = (
    query: InvoiceRemindersControllerListInvoiceRemindersParams = {},
    params: RequestParams = {},
  ) =>
    this.request<InvoiceReminderResponseDto[], void>({
      path: `/api/invoice-reminders`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-reminders
   * @name InvoiceRemindersControllerUpdateInvoiceReminder
   * @summary Dismiss a scheduled reminder, or restore a dismissed one
   * @request PATCH:/api/invoice-reminders/{id}
   */
  invoiceRemindersControllerUpdateInvoiceReminder = (
    { id }: InvoiceRemindersControllerUpdateInvoiceReminderParams,
    data: UpdateInvoiceReminderDto,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceReminderResponseDto, void>({
      path: `/api/invoice-reminders/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags invoice-reminders
   * @name InvoiceRemindersControllerStopInvoiceReminders
   * @summary Dismiss all of an invoice's scheduled reminders
   * @request POST:/api/invoices/{id}/reminders/stop
   */
  invoiceRemindersControllerStopInvoiceReminders = (
    { id }: InvoiceRemindersControllerStopInvoiceRemindersParams,
    params: RequestParams = {},
  ) =>
    this.request<StopInvoiceRemindersResponseDto, void>({
      path: `/api/invoices/${id}/reminders/stop`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags stripe
   * @name StripeControllerStartOnboarding
   * @summary Start Stripe Connect onboarding
   * @request POST:/api/stripe/connect/onboard
   * @secure
   */
  stripeControllerStartOnboarding = (params: RequestParams = {}) =>
    this.request<StripeOnboardingResponseDto, void>({
      path: `/api/stripe/connect/onboard`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags stripe
   * @name StripeControllerGetConnectionStatus
   * @summary Get Stripe connection status
   * @request GET:/api/stripe/connect/status
   * @secure
   */
  stripeControllerGetConnectionStatus = (params: RequestParams = {}) =>
    this.request<StripeConnectionResponseDto, void>({
      path: `/api/stripe/connect/status`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags stripe
   * @name StripeControllerRefreshConnection
   * @summary Refresh Stripe connection status from Stripe API
   * @request POST:/api/stripe/connect/refresh
   * @secure
   */
  stripeControllerRefreshConnection = (params: RequestParams = {}) =>
    this.request<StripeRefreshResponseDto, void>({
      path: `/api/stripe/connect/refresh`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags stripe
   * @name StripeControllerDisconnect
   * @summary Disconnect Stripe account
   * @request DELETE:/api/stripe/connect
   * @secure
   */
  stripeControllerDisconnect = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/stripe/connect`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags stripe
   * @name StripeControllerGetPaymentUrl
   * @summary Get or create a Stripe Checkout payment URL for an invoice
   * @request POST:/api/stripe/invoices/{invoiceId}/payment-url
   * @secure
   */
  stripeControllerGetPaymentUrl = (
    { invoiceId }: StripeControllerGetPaymentUrlParams,
    params: RequestParams = {},
  ) =>
    this.request<StripePaymentUrlResponseDto, void>({
      path: `/api/stripe/invoices/${invoiceId}/payment-url`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags stripe
   * @name StripeControllerListPayments
   * @summary List payments for an invoice
   * @request GET:/api/stripe/invoices/{invoiceId}/payments
   * @secure
   */
  stripeControllerListPayments = (
    { invoiceId }: StripeControllerListPaymentsParams,
    params: RequestParams = {},
  ) =>
    this.request<PaymentResponseDto[], void>({
      path: `/api/stripe/invoices/${invoiceId}/payments`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags notifications
   * @name NotificationsControllerListNotifications
   * @summary List notifications for current user
   * @request GET:/api/notifications
   */
  notificationsControllerListNotifications = (
    query: NotificationsControllerListNotificationsParams = {},
    params: RequestParams = {},
  ) =>
    this.request<NotificationResponseDto[], void>({
      path: `/api/notifications`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags notifications
   * @name NotificationsControllerGetUnreadCount
   * @summary Get unread notification count
   * @request GET:/api/notifications/unread-count
   */
  notificationsControllerGetUnreadCount = (params: RequestParams = {}) =>
    this.request<UnreadCountResponseDto, void>({
      path: `/api/notifications/unread-count`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags notifications
   * @name NotificationsControllerGetActionable
   * @summary Get actionable notifications for dashboard widget
   * @request GET:/api/notifications/actionable
   */
  notificationsControllerGetActionable = (params: RequestParams = {}) =>
    this.request<ActionableResponseDto, void>({
      path: `/api/notifications/actionable`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * Combines listNotifications, unread-count, and actionable into a single response so
   * polling consumers issue one request instead of three.
   *
   * @tags notifications
   * @name NotificationsControllerGetSummary
   * @summary Get notifications, unread count, and actionable items in one call
   * @request GET:/api/notifications/summary
   */
  notificationsControllerGetSummary = (
    query: NotificationsControllerGetSummaryParams = {},
    params: RequestParams = {},
  ) =>
    this.request<NotificationsSummaryResponseDto, void>({
      path: `/api/notifications/summary`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags notifications
   * @name NotificationsControllerMarkRead
   * @summary Mark a notification as read
   * @request PATCH:/api/notifications/{id}/read
   */
  notificationsControllerMarkRead = (
    { id }: NotificationsControllerMarkReadParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/notifications/${id}/read`,
      method: 'PATCH',
      ...params,
    })
  /**
   * No description
   *
   * @tags notifications
   * @name NotificationsControllerMarkAllRead
   * @summary Mark all notifications as read
   * @request POST:/api/notifications/mark-all-read
   */
  notificationsControllerMarkAllRead = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/notifications/mark-all-read`,
      method: 'POST',
      ...params,
    })
  /**
   * No description
   *
   * @tags notifications
   * @name NotificationsControllerSnooze
   * @summary Snooze a notification until a specific time
   * @request POST:/api/notifications/{id}/snooze
   */
  notificationsControllerSnooze = (
    { id }: NotificationsControllerSnoozeParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/notifications/${id}/snooze`,
      method: 'POST',
      ...params,
    })
  /**
   * No description
   *
   * @tags notifications
   * @name NotificationsControllerDismissAll
   * @summary Dismiss all unread notifications
   * @request POST:/api/notifications/dismiss-all
   */
  notificationsControllerDismissAll = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/notifications/dismiss-all`,
      method: 'POST',
      ...params,
    })
  /**
   * No description
   *
   * @tags notification-preferences
   * @name NotificationPreferencesControllerListPreferences
   * @summary List notification preferences
   * @request GET:/api/notification-preferences
   */
  notificationPreferencesControllerListPreferences = (params: RequestParams = {}) =>
    this.request<NotificationPreferenceResponseDto[], void>({
      path: `/api/notification-preferences`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags notification-preferences
   * @name NotificationPreferencesControllerUpdatePreferences
   * @summary Bulk update notification preferences
   * @request PUT:/api/notification-preferences
   */
  notificationPreferencesControllerUpdatePreferences = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/notification-preferences`,
      method: 'PUT',
      ...params,
    })
  /**
   * No description
   *
   * @tags notifications
   * @name PushSubscriptionsControllerCreate
   * @summary Register a Web Push subscription for the current device
   * @request POST:/api/notifications/push-subscriptions
   */
  pushSubscriptionsControllerCreate = (params: RequestParams = {}) =>
    this.request<PushSubscriptionResponseDto, void>({
      path: `/api/notifications/push-subscriptions`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags notifications
   * @name PushSubscriptionsControllerRemove
   * @summary Unregister a Web Push subscription
   * @request DELETE:/api/notifications/push-subscriptions/{id}
   */
  pushSubscriptionsControllerRemove = (
    { id }: PushSubscriptionsControllerRemoveParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/notifications/push-subscriptions/${id}`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerListQuotes
   * @summary List quotes (latest revision per quoteNumber)
   * @request GET:/api/quotes
   * @secure
   */
  quotesControllerListQuotes = (
    query: QuotesControllerListQuotesParams = {},
    params: RequestParams = {},
  ) =>
    this.request<QuoteResponseDto[], void>({
      path: `/api/quotes`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerCreateQuote
   * @summary Create a new quote
   * @request POST:/api/quotes
   * @secure
   */
  quotesControllerCreateQuote = (data: CreateQuoteDto, params: RequestParams = {}) =>
    this.request<QuoteResponseDto, void>({
      path: `/api/quotes`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerGetQuote
   * @summary Get quote by ID
   * @request GET:/api/quotes/{id}
   * @secure
   */
  quotesControllerGetQuote = (
    { id }: QuotesControllerGetQuoteParams,
    params: RequestParams = {},
  ) =>
    this.request<QuoteResponseDto, void>({
      path: `/api/quotes/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerUpdateQuote
   * @summary Update a DRAFT quote
   * @request PATCH:/api/quotes/{id}
   * @secure
   */
  quotesControllerUpdateQuote = (
    { id }: QuotesControllerUpdateQuoteParams,
    data: UpdateQuoteDto,
    params: RequestParams = {},
  ) =>
    this.request<QuoteResponseDto, void>({
      path: `/api/quotes/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerDeleteQuote
   * @summary Delete a DRAFT quote
   * @request DELETE:/api/quotes/{id}
   * @secure
   */
  quotesControllerDeleteQuote = (
    { id }: QuotesControllerDeleteQuoteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/quotes/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerGetQuotePreview
   * @summary Render quote as HTML preview
   * @request GET:/api/quotes/{id}/preview
   * @secure
   */
  quotesControllerGetQuotePreview = (
    { id }: QuotesControllerGetQuotePreviewParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/quotes/${id}/preview`,
      method: 'GET',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerArchiveQuote
   * @summary Archive a quote
   * @request POST:/api/quotes/{id}/archive
   * @secure
   */
  quotesControllerArchiveQuote = (
    { id }: QuotesControllerArchiveQuoteParams,
    params: RequestParams = {},
  ) =>
    this.request<QuoteResponseDto, void>({
      path: `/api/quotes/${id}/archive`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerUnarchiveQuote
   * @summary Unarchive a quote
   * @request POST:/api/quotes/{id}/unarchive
   * @secure
   */
  quotesControllerUnarchiveQuote = (
    { id }: QuotesControllerUnarchiveQuoteParams,
    params: RequestParams = {},
  ) =>
    this.request<QuoteResponseDto, void>({
      path: `/api/quotes/${id}/unarchive`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerUpdateStatus
   * @summary Transition quote status
   * @request PATCH:/api/quotes/{id}/status
   * @secure
   */
  quotesControllerUpdateStatus = (
    { id }: QuotesControllerUpdateStatusParams,
    data: UpdateQuoteStatusDto,
    params: RequestParams = {},
  ) =>
    this.request<QuoteResponseDto, void>({
      path: `/api/quotes/${id}/status`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerSendQuote
   * @summary Send a quote to the client via email
   * @request POST:/api/quotes/{id}/send
   * @secure
   */
  quotesControllerSendQuote = (
    { id }: QuotesControllerSendQuoteParams,
    data: SendQuoteDto,
    params: RequestParams = {},
  ) =>
    this.request<SendQuoteResponseDto, void>({
      path: `/api/quotes/${id}/send`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerSupersede
   * @summary Supersede a quote and create a new DRAFT revision
   * @request POST:/api/quotes/{id}/supersede
   * @secure
   */
  quotesControllerSupersede = (
    { id }: QuotesControllerSupersedeParams,
    params: RequestParams = {},
  ) =>
    this.request<QuoteResponseDto, void>({
      path: `/api/quotes/${id}/supersede`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerConvert
   * @summary Convert an ACCEPTED quote to an invoice
   * @request POST:/api/quotes/{id}/convert
   * @secure
   */
  quotesControllerConvert = (
    { id }: QuotesControllerConvertParams,
    data: ConvertQuoteDto,
    params: RequestParams = {},
  ) =>
    this.request<ConvertedQuoteResponseDto, void>({
      path: `/api/quotes/${id}/convert`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerConvertSplit
   * @summary Split an ACCEPTED quote into 2-5 milestone DRAFT invoices
   * @request POST:/api/quotes/{id}/convert-split
   * @secure
   */
  quotesControllerConvertSplit = (
    { id }: QuotesControllerConvertSplitParams,
    data: ConvertQuoteSplitDto,
    params: RequestParams = {},
  ) =>
    this.request<ConvertedQuoteSplitResponseDto, void>({
      path: `/api/quotes/${id}/convert-split`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerGetRevisions
   * @summary List all revisions for a quote number group
   * @request GET:/api/quotes/{id}/revisions
   * @secure
   */
  quotesControllerGetRevisions = (
    { id }: QuotesControllerGetRevisionsParams,
    params: RequestParams = {},
  ) =>
    this.request<QuoteRevisionSummaryDto[], void>({
      path: `/api/quotes/${id}/revisions`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerAssignTags
   * @summary Assign tags to a quote
   * @request POST:/api/quotes/{id}/tags
   * @secure
   */
  quotesControllerAssignTags = (
    { id }: QuotesControllerAssignTagsParams,
    data: AssignTagsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/quotes/${id}/tags`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    })
  /**
   * No description
   *
   * @tags quotes
   * @name QuotesControllerRemoveTag
   * @summary Remove a tag from a quote
   * @request DELETE:/api/quotes/{id}/tags/{tagId}
   * @secure
   */
  quotesControllerRemoveTag = (
    { tagId, id }: QuotesControllerRemoveTagParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/quotes/${id}/tags/${tagId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags quote-line-items
   * @name QuoteLineItemsControllerListQuoteLineItems
   * @summary List line items on a quote
   * @request GET:/api/quotes/{quoteId}/line-items
   * @secure
   */
  quoteLineItemsControllerListQuoteLineItems = (
    { quoteId }: QuoteLineItemsControllerListQuoteLineItemsParams,
    params: RequestParams = {},
  ) =>
    this.request<QuoteLineItemResponseDto[], void>({
      path: `/api/quotes/${quoteId}/line-items`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quote-line-items
   * @name QuoteLineItemsControllerBatchUpdateLineItems
   * @summary Batch update all line items on a quote
   * @request PUT:/api/quotes/{quoteId}/line-items
   * @secure
   */
  quoteLineItemsControllerBatchUpdateLineItems = (
    { quoteId }: QuoteLineItemsControllerBatchUpdateLineItemsParams,
    data: BatchUpdateQuoteLineItemsDto,
    params: RequestParams = {},
  ) =>
    this.request<QuoteLineItemResponseDto[], void>({
      path: `/api/quotes/${quoteId}/line-items`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quote-line-items
   * @name QuoteLineItemsControllerAddQuoteLineItem
   * @summary Add a line item to a quote
   * @request POST:/api/quotes/{quoteId}/line-items
   * @secure
   */
  quoteLineItemsControllerAddQuoteLineItem = (
    { quoteId }: QuoteLineItemsControllerAddQuoteLineItemParams,
    data: CreateQuoteLineItemDto,
    params: RequestParams = {},
  ) =>
    this.request<QuoteLineItemResponseDto, void>({
      path: `/api/quotes/${quoteId}/line-items`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quote-line-items
   * @name QuoteLineItemsControllerUpdateQuoteLineItem
   * @summary Update a quote line item
   * @request PATCH:/api/quotes/{quoteId}/line-items/{itemId}
   * @secure
   */
  quoteLineItemsControllerUpdateQuoteLineItem = (
    { itemId, quoteId }: QuoteLineItemsControllerUpdateQuoteLineItemParams,
    data: UpdateQuoteLineItemDto,
    params: RequestParams = {},
  ) =>
    this.request<QuoteLineItemResponseDto, void>({
      path: `/api/quotes/${quoteId}/line-items/${itemId}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quote-line-items
   * @name QuoteLineItemsControllerDeleteQuoteLineItem
   * @summary Remove a line item from a quote
   * @request DELETE:/api/quotes/{quoteId}/line-items/{itemId}
   * @secure
   */
  quoteLineItemsControllerDeleteQuoteLineItem = (
    { itemId, quoteId }: QuoteLineItemsControllerDeleteQuoteLineItemParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/quotes/${quoteId}/line-items/${itemId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags quote-line-items
   * @name QuoteLineItemsControllerSyncQuoteLineItem
   * @summary Re-attach a detached quote line item to catalogue values
   * @request PATCH:/api/quotes/{quoteId}/line-items/{itemId}/sync
   * @secure
   */
  quoteLineItemsControllerSyncQuoteLineItem = (
    { itemId, quoteId }: QuoteLineItemsControllerSyncQuoteLineItemParams,
    params: RequestParams = {},
  ) =>
    this.request<QuoteLineItemResponseDto, void>({
      path: `/api/quotes/${quoteId}/line-items/${itemId}/sync`,
      method: 'PATCH',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quote-pdf
   * @name QuotePdfControllerGeneratePdf
   * @summary Generate a new PDF version for a quote
   * @request POST:/api/quotes/{quoteId}/pdf
   * @secure
   */
  quotePdfControllerGeneratePdf = (
    { quoteId }: QuotePdfControllerGeneratePdfParams,
    params: RequestParams = {},
  ) =>
    this.request<QuotePdfVersionResponseDto, void>({
      path: `/api/quotes/${quoteId}/pdf`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quote-pdf
   * @name QuotePdfControllerListVersions
   * @summary List all PDF versions for a quote
   * @request GET:/api/quotes/{quoteId}/pdf/versions
   * @secure
   */
  quotePdfControllerListVersions = (
    { quoteId }: QuotePdfControllerListVersionsParams,
    params: RequestParams = {},
  ) =>
    this.request<QuotePdfVersionResponseDto[], void>({
      path: `/api/quotes/${quoteId}/pdf/versions`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quote-pdf
   * @name QuotePdfControllerGetVersionSignedUrl
   * @summary Get a signed URL for a specific PDF version
   * @request GET:/api/quotes/{quoteId}/pdf/versions/{versionId}
   * @secure
   */
  quotePdfControllerGetVersionSignedUrl = (
    { versionId, quoteId }: QuotePdfControllerGetVersionSignedUrlParams,
    params: RequestParams = {},
  ) =>
    this.request<QuotePdfSignedUrlResponseDto, void>({
      path: `/api/quotes/${quoteId}/pdf/versions/${versionId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quote-pdf
   * @name QuotePdfControllerGetLatestSignedUrl
   * @summary Get a signed URL for the latest PDF version
   * @request GET:/api/quotes/{quoteId}/pdf/latest
   * @secure
   */
  quotePdfControllerGetLatestSignedUrl = (
    { quoteId }: QuotePdfControllerGetLatestSignedUrlParams,
    params: RequestParams = {},
  ) =>
    this.request<QuotePdfSignedUrlResponseDto, void>({
      path: `/api/quotes/${quoteId}/pdf/latest`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags quote-pdf
   * @name QuotePdfControllerPreviewTemplate
   * @summary Preview the quote template as HTML (dev only)
   * @request GET:/api/quotes/{quoteId}/pdf/preview
   * @secure
   */
  quotePdfControllerPreviewTemplate = (
    { quoteId }: QuotePdfControllerPreviewTemplateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/quotes/${quoteId}/pdf/preview`,
      method: 'GET',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags dev-settings
   * @name DevSettingsControllerGetDevSettings
   * @summary Get this tenant's dev-mode email divert override
   * @request GET:/api/dev-settings
   */
  devSettingsControllerGetDevSettings = (params: RequestParams = {}) =>
    this.request<DevSettingsResponseDto, void>({
      path: `/api/dev-settings`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags dev-settings
   * @name DevSettingsControllerUpdateDevSettings
   * @summary Update this tenant's dev-mode email divert override
   * @request PATCH:/api/dev-settings
   */
  devSettingsControllerUpdateDevSettings = (params: RequestParams = {}) =>
    this.request<DevSettingsResponseDto, void>({
      path: `/api/dev-settings`,
      method: 'PATCH',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags dev-settings
   * @name DevSettingsControllerTriggerTestError
   * @summary Trigger a test error to verify Sentry error capture is wired up
   * @request POST:/api/dev-settings/test-error
   */
  devSettingsControllerTriggerTestError = (params: RequestParams = {}) =>
    this.request<any, void>({
      path: `/api/dev-settings/test-error`,
      method: 'POST',
      ...params,
    })
  /**
   * No description
   *
   * @tags dev-settings
   * @name DevSettingsControllerResetOnboarding
   * @summary Reset this tenant's onboarding-celebration flag and the current user's dismissed onboarding cards
   * @request POST:/api/dev-settings/reset-onboarding
   */
  devSettingsControllerResetOnboarding = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/dev-settings/reset-onboarding`,
      method: 'POST',
      ...params,
    })
  /**
   * No description
   *
   * @tags health
   * @name HealthControllerGetHealth
   * @summary Health check
   * @request GET:/api/health
   */
  healthControllerGetHealth = (params: RequestParams = {}) =>
    this.request<HealthResponseDto, any>({
      path: `/api/health`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-invoices
   * @name RecurringInvoicesControllerList
   * @summary List recurring invoices
   * @request GET:/api/recurring-invoices
   * @secure
   */
  recurringInvoicesControllerList = (
    query: RecurringInvoicesControllerListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<RecurringInvoiceResponseDto[], void>({
      path: `/api/recurring-invoices`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-invoices
   * @name RecurringInvoicesControllerCreate
   * @summary Create recurring invoice
   * @request POST:/api/recurring-invoices
   * @secure
   */
  recurringInvoicesControllerCreate = (
    data: CreateRecurringInvoiceDto,
    params: RequestParams = {},
  ) =>
    this.request<RecurringInvoiceResponseDto, void>({
      path: `/api/recurring-invoices`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-invoices
   * @name RecurringInvoicesControllerStats
   * @summary Get recurring invoice schedule stats
   * @request GET:/api/recurring-invoices/stats
   * @secure
   */
  recurringInvoicesControllerStats = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/recurring-invoices/stats`,
      method: 'GET',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-invoices
   * @name RecurringInvoicesControllerGetOne
   * @summary Get recurring invoice with line items
   * @request GET:/api/recurring-invoices/{id}
   * @secure
   */
  recurringInvoicesControllerGetOne = (
    { id }: RecurringInvoicesControllerGetOneParams,
    params: RequestParams = {},
  ) =>
    this.request<RecurringInvoiceDetailResponseDto, void>({
      path: `/api/recurring-invoices/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-invoices
   * @name RecurringInvoicesControllerUpdate
   * @summary Update recurring invoice
   * @request PATCH:/api/recurring-invoices/{id}
   * @secure
   */
  recurringInvoicesControllerUpdate = (
    { id }: RecurringInvoicesControllerUpdateParams,
    data: UpdateRecurringInvoiceDto,
    params: RequestParams = {},
  ) =>
    this.request<RecurringInvoiceResponseDto, void>({
      path: `/api/recurring-invoices/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-invoices
   * @name RecurringInvoicesControllerRemove
   * @summary Delete recurring invoice (only if no generated invoices)
   * @request DELETE:/api/recurring-invoices/{id}
   * @secure
   */
  recurringInvoicesControllerRemove = (
    { id }: RecurringInvoicesControllerRemoveParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/recurring-invoices/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-invoices
   * @name RecurringInvoicesControllerUpdateStatus
   * @summary Transition recurring invoice status (ACTIVE ↔ PAUSED → CANCELLED)
   * @request PATCH:/api/recurring-invoices/{id}/status
   * @secure
   */
  recurringInvoicesControllerUpdateStatus = (
    { id }: RecurringInvoicesControllerUpdateStatusParams,
    data: UpdateRecurringInvoiceStatusDto,
    params: RequestParams = {},
  ) =>
    this.request<RecurringInvoiceResponseDto, void>({
      path: `/api/recurring-invoices/${id}/status`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-invoices
   * @name RecurringInvoicesControllerTrigger
   * @summary Manually trigger a run for a recurring invoice
   * @request POST:/api/recurring-invoices/{id}/trigger
   * @secure
   */
  recurringInvoicesControllerTrigger = (
    { id }: RecurringInvoicesControllerTriggerParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/recurring-invoices/${id}/trigger`,
      method: 'POST',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-expenses
   * @name RecurringExpensesControllerList
   * @summary List recurring expenses
   * @request GET:/api/recurring-expenses
   * @secure
   */
  recurringExpensesControllerList = (
    query: RecurringExpensesControllerListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<RecurringExpenseResponseDto[], void>({
      path: `/api/recurring-expenses`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-expenses
   * @name RecurringExpensesControllerCreate
   * @summary Create a recurring expense (starts PAUSED)
   * @request POST:/api/recurring-expenses
   * @secure
   */
  recurringExpensesControllerCreate = (
    data: CreateRecurringBusinessExpenseDto | CreateRecurringReimbursementExpenseDto,
    params: RequestParams = {},
  ) =>
    this.request<RecurringExpenseResponseDto, void>({
      path: `/api/recurring-expenses`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-expenses
   * @name RecurringExpensesControllerStats
   * @summary Get recurring expense schedule stats
   * @request GET:/api/recurring-expenses/stats
   * @secure
   */
  recurringExpensesControllerStats = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/recurring-expenses/stats`,
      method: 'GET',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-expenses
   * @name RecurringExpensesControllerGetOne
   * @summary Get a recurring expense
   * @request GET:/api/recurring-expenses/{id}
   * @secure
   */
  recurringExpensesControllerGetOne = (
    { id }: RecurringExpensesControllerGetOneParams,
    params: RequestParams = {},
  ) =>
    this.request<RecurringExpenseResponseDto, void>({
      path: `/api/recurring-expenses/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-expenses
   * @name RecurringExpensesControllerUpdate
   * @summary Update a recurring expense
   * @request PATCH:/api/recurring-expenses/{id}
   * @secure
   */
  recurringExpensesControllerUpdate = (
    { id }: RecurringExpensesControllerUpdateParams,
    data: UpdateRecurringBusinessExpenseDto | UpdateRecurringReimbursementExpenseDto,
    params: RequestParams = {},
  ) =>
    this.request<RecurringExpenseResponseDto, void>({
      path: `/api/recurring-expenses/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-expenses
   * @name RecurringExpensesControllerRemove
   * @summary Delete recurring expense (PAUSED or CANCELLED only)
   * @request DELETE:/api/recurring-expenses/{id}
   * @secure
   */
  recurringExpensesControllerRemove = (
    { id }: RecurringExpensesControllerRemoveParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/recurring-expenses/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-expenses
   * @name RecurringExpensesControllerActivate
   * @summary Transition PAUSED → ACTIVE; sets nextRunAt
   * @request POST:/api/recurring-expenses/{id}/activate
   * @secure
   */
  recurringExpensesControllerActivate = (
    { id }: RecurringExpensesControllerActivateParams,
    params: RequestParams = {},
  ) =>
    this.request<RecurringExpenseResponseDto, void>({
      path: `/api/recurring-expenses/${id}/activate`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-expenses
   * @name RecurringExpensesControllerPause
   * @summary Transition ACTIVE → PAUSED; clears nextRunAt
   * @request POST:/api/recurring-expenses/{id}/pause
   * @secure
   */
  recurringExpensesControllerPause = (
    { id }: RecurringExpensesControllerPauseParams,
    params: RequestParams = {},
  ) =>
    this.request<RecurringExpenseResponseDto, void>({
      path: `/api/recurring-expenses/${id}/pause`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-expenses
   * @name RecurringExpensesControllerCancel
   * @summary Transition ACTIVE/PAUSED → CANCELLED
   * @request POST:/api/recurring-expenses/{id}/cancel
   * @secure
   */
  recurringExpensesControllerCancel = (
    { id }: RecurringExpensesControllerCancelParams,
    params: RequestParams = {},
  ) =>
    this.request<RecurringExpenseResponseDto, void>({
      path: `/api/recurring-expenses/${id}/cancel`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-expenses
   * @name RecurringExpensesControllerTrigger
   * @summary Manually trigger a run for an ACTIVE recurring expense now
   * @request POST:/api/recurring-expenses/{id}/trigger
   * @secure
   */
  recurringExpensesControllerTrigger = (
    { id }: RecurringExpensesControllerTriggerParams,
    params: RequestParams = {},
  ) =>
    this.request<RecurringExpenseResponseDto, void>({
      path: `/api/recurring-expenses/${id}/trigger`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags recurring-expenses
   * @name RecurringExpensesControllerListRuns
   * @summary List run history for a recurring expense
   * @request GET:/api/recurring-expenses/{id}/runs
   * @secure
   */
  recurringExpensesControllerListRuns = (
    { id }: RecurringExpensesControllerListRunsParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/recurring-expenses/${id}/runs`,
      method: 'GET',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerListUsers
   * @summary List tenant members
   * @request GET:/api/users
   */
  usersControllerListUsers = (
    query: UsersControllerListUsersParams = {},
    params: RequestParams = {},
  ) =>
    this.request<UserResponseDto[], void>({
      path: `/api/users`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerListPendingInvitations
   * @summary List pending invitations
   * @request GET:/api/users/invitations
   */
  usersControllerListPendingInvitations = (params: RequestParams = {}) =>
    this.request<UserInvitationResponseDto[], void>({
      path: `/api/users/invitations`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerInviteUser
   * @summary Invite a new user by email
   * @request POST:/api/users/invitations
   */
  usersControllerInviteUser = (params: RequestParams = {}) =>
    this.request<UserInvitationResponseDto, void>({
      path: `/api/users/invitations`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerGetUsersSummary
   * @summary Get Active/Deactivated member counts
   * @request GET:/api/users/summary
   */
  usersControllerGetUsersSummary = (params: RequestParams = {}) =>
    this.request<UsersSummaryResponseDto, void>({
      path: `/api/users/summary`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerResetPassword
   * @summary Email the target user a password-reset link
   * @request POST:/api/users/{id}/reset-password
   */
  usersControllerResetPassword = (
    { id }: UsersControllerResetPasswordParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/users/${id}/reset-password`,
      method: 'POST',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerCancelInvitation
   * @summary Cancel a pending invitation
   * @request DELETE:/api/users/invitations/{id}
   */
  usersControllerCancelInvitation = (
    { id }: UsersControllerCancelInvitationParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/users/invitations/${id}`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerUpdateUserRole
   * @summary Update a user role
   * @request PATCH:/api/users/{id}/role
   */
  usersControllerUpdateUserRole = (
    { id }: UsersControllerUpdateUserRoleParams,
    params: RequestParams = {},
  ) =>
    this.request<UserResponseDto, void>({
      path: `/api/users/${id}/role`,
      method: 'PATCH',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerDeactivateUser
   * @summary Deactivate a user and revoke their sessions
   * @request PATCH:/api/users/{id}/deactivate
   */
  usersControllerDeactivateUser = (
    { id }: UsersControllerDeactivateUserParams,
    params: RequestParams = {},
  ) =>
    this.request<UserResponseDto, void>({
      path: `/api/users/${id}/deactivate`,
      method: 'PATCH',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerReactivateUser
   * @summary Reactivate a deactivated user
   * @request PATCH:/api/users/{id}/reactivate
   */
  usersControllerReactivateUser = (
    { id }: UsersControllerReactivateUserParams,
    params: RequestParams = {},
  ) =>
    this.request<UserResponseDto, void>({
      path: `/api/users/${id}/reactivate`,
      method: 'PATCH',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerUploadAvatar
   * @summary Upload or replace the current user avatar
   * @request POST:/api/users/me/avatar
   */
  usersControllerUploadAvatar = (params: RequestParams = {}) =>
    this.request<UserAvatarResponseDto, void>({
      path: `/api/users/me/avatar`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerDeleteAvatar
   * @summary Remove the current user avatar
   * @request DELETE:/api/users/me/avatar
   */
  usersControllerDeleteAvatar = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/users/me/avatar`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerGetOnboardingStatus
   * @summary Get the current user onboarding card dismissal status
   * @request GET:/api/users/me/onboarding
   */
  usersControllerGetOnboardingStatus = (params: RequestParams = {}) =>
    this.request<OnboardingStatusResponseDto, void>({
      path: `/api/users/me/onboarding`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerDismissOnboardingCard
   * @summary Dismiss a single onboarding card for the current user
   * @request PATCH:/api/users/me/onboarding
   */
  usersControllerDismissOnboardingCard = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/users/me/onboarding`,
      method: 'PATCH',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerGetTwoFactorNudgePreference
   * @summary Get the current two-factor adoption reminder email preference
   * @request GET:/api/users/me/two-factor-nudge-preference
   */
  usersControllerGetTwoFactorNudgePreference = (params: RequestParams = {}) =>
    this.request<TwoFactorNudgePreferenceResponseDto, void>({
      path: `/api/users/me/two-factor-nudge-preference`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags users
   * @name UsersControllerUpdateTwoFactorNudgePreference
   * @summary Opt in or out of two-factor adoption reminder emails
   * @request PATCH:/api/users/me/two-factor-nudge-preference
   */
  usersControllerUpdateTwoFactorNudgePreference = (params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/users/me/two-factor-nudge-preference`,
      method: 'PATCH',
      ...params,
    })
  /**
   * No description
   *
   * @tags tenant-membership
   * @name TenantMembershipControllerListMyTenants
   * @request GET:/api/users/me/tenants
   */
  tenantMembershipControllerListMyTenants = (params: RequestParams = {}) =>
    this.request<TenantMembershipResponseDto[], void>({
      path: `/api/users/me/tenants`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags line-items
   * @name LineItemsControllerListLineItems
   * @summary List registry line items
   * @request GET:/api/line-items
   * @secure
   */
  lineItemsControllerListLineItems = (
    query: LineItemsControllerListLineItemsParams = {},
    params: RequestParams = {},
  ) =>
    this.request<LineItemResponseDto[], void>({
      path: `/api/line-items`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags line-items
   * @name LineItemsControllerCreateLineItem
   * @summary Create a registry line item
   * @request POST:/api/line-items
   * @secure
   */
  lineItemsControllerCreateLineItem = (
    data: CreateLineItemDto,
    params: RequestParams = {},
  ) =>
    this.request<LineItemResponseDto, void>({
      path: `/api/line-items`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags line-items
   * @name LineItemsControllerSuggestLineItems
   * @summary Fuzzy title suggestions from registry
   * @request GET:/api/line-items/suggest
   * @secure
   */
  lineItemsControllerSuggestLineItems = (
    query: LineItemsControllerSuggestLineItemsParams,
    params: RequestParams = {},
  ) =>
    this.request<LineItemSuggestionResponseDto[], void>({
      path: `/api/line-items/suggest`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags line-items
   * @name LineItemsControllerGetLineItem
   * @summary Get a registry line item
   * @request GET:/api/line-items/{id}
   * @secure
   */
  lineItemsControllerGetLineItem = (
    { id }: LineItemsControllerGetLineItemParams,
    params: RequestParams = {},
  ) =>
    this.request<LineItemResponseDto, void>({
      path: `/api/line-items/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags line-items
   * @name LineItemsControllerUpdateLineItem
   * @summary Update a registry line item
   * @request PATCH:/api/line-items/{id}
   * @secure
   */
  lineItemsControllerUpdateLineItem = (
    { id }: LineItemsControllerUpdateLineItemParams,
    data: UpdateLineItemDto,
    params: RequestParams = {},
  ) =>
    this.request<LineItemResponseDto, void>({
      path: `/api/line-items/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags line-items
   * @name LineItemsControllerDeleteLineItem
   * @summary Delete a registry line item (snapshots any live invoice attachments)
   * @request DELETE:/api/line-items/{id}
   * @secure
   */
  lineItemsControllerDeleteLineItem = (
    { id }: LineItemsControllerDeleteLineItemParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/line-items/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags line-items
   * @name LineItemsControllerAssignTags
   * @summary Assign tags to a line item
   * @request POST:/api/line-items/{id}/tags
   * @secure
   */
  lineItemsControllerAssignTags = (
    { id }: LineItemsControllerAssignTagsParams,
    data: AssignTagsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/line-items/${id}/tags`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    })
  /**
   * No description
   *
   * @tags line-items
   * @name LineItemsControllerRemoveTag
   * @summary Remove a tag from a line item
   * @request DELETE:/api/line-items/{id}/tags/{tagId}
   * @secure
   */
  lineItemsControllerRemoveTag = (
    { tagId, id }: LineItemsControllerRemoveTagParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/line-items/${id}/tags/${tagId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
  /**
   * No description
   *
   * @tags Invitations
   * @name InvitationAcceptanceControllerGetPreview
   * @request GET:/api/invitations/{token}
   */
  invitationAcceptanceControllerGetPreview = (
    { token }: InvitationAcceptanceControllerGetPreviewParams,
    params: RequestParams = {},
  ) =>
    this.request<InvitationPreviewDto, void>({
      path: `/api/invitations/${token}`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags Invitations
   * @name InvitationAcceptanceControllerAccept
   * @request POST:/api/invitations/{token}/accept
   */
  invitationAcceptanceControllerAccept = (
    { token }: InvitationAcceptanceControllerAcceptParams,
    params: RequestParams = {},
  ) =>
    this.request<AcceptInvitationResponseDto, void>({
      path: `/api/invitations/${token}/accept`,
      method: 'POST',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportsControllerGetInvoiceSummary
   * @request GET:/api/reports/invoices
   */
  reportsControllerGetInvoiceSummary = (
    query: ReportsControllerGetInvoiceSummaryParams = {},
    params: RequestParams = {},
  ) =>
    this.request<InvoiceSummaryResponseDto, any>({
      path: `/api/reports/invoices`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportsControllerGetClientReport
   * @request GET:/api/reports/clients
   */
  reportsControllerGetClientReport = (
    query: ReportsControllerGetClientReportParams = {},
    params: RequestParams = {},
  ) =>
    this.request<ClientReportResponseDto, any>({
      path: `/api/reports/clients`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportsControllerGetLineItemReport
   * @request GET:/api/reports/line-items
   */
  reportsControllerGetLineItemReport = (
    query: ReportsControllerGetLineItemReportParams = {},
    params: RequestParams = {},
  ) =>
    this.request<LineItemReportResponseDto, any>({
      path: `/api/reports/line-items`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportsControllerGetRevenueTimeline
   * @request GET:/api/reports/revenue-timeline
   */
  reportsControllerGetRevenueTimeline = (
    query: ReportsControllerGetRevenueTimelineParams = {},
    params: RequestParams = {},
  ) =>
    this.request<RevenueTimelineResponseDto, any>({
      path: `/api/reports/revenue-timeline`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportsControllerGetAging
   * @request GET:/api/reports/aging
   */
  reportsControllerGetAging = (
    query: ReportsControllerGetAgingParams = {},
    params: RequestParams = {},
  ) =>
    this.request<AgingResponseDto, any>({
      path: `/api/reports/aging`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportsControllerGetRevenueByTag
   * @request GET:/api/reports/revenue-by-tag
   */
  reportsControllerGetRevenueByTag = (
    query: ReportsControllerGetRevenueByTagParams = {},
    params: RequestParams = {},
  ) =>
    this.request<TagRevenueResponseDto, any>({
      path: `/api/reports/revenue-by-tag`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportsControllerGetExpenseReport
   * @request GET:/api/reports/expenses
   */
  reportsControllerGetExpenseReport = (
    query: ReportsControllerGetExpenseReportParams = {},
    params: RequestParams = {},
  ) =>
    this.request<ExpenseReportResponseDto, any>({
      path: `/api/reports/expenses`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportsControllerGetTaxReport
   * @request GET:/api/reports/tax
   */
  reportsControllerGetTaxReport = (
    query: ReportsControllerGetTaxReportParams,
    params: RequestParams = {},
  ) =>
    this.request<TaxReportResponseDto, any>({
      path: `/api/reports/tax`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportsControllerGetBasSummary
   * @request GET:/api/reports/bas-summary
   */
  reportsControllerGetBasSummary = (
    query: ReportsControllerGetBasSummaryParams,
    params: RequestParams = {},
  ) =>
    this.request<BasSummaryResponseDto, any>({
      path: `/api/reports/bas-summary`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportsControllerGetProfitAndLoss
   * @request GET:/api/reports/profit-and-loss
   */
  reportsControllerGetProfitAndLoss = (
    query: ReportsControllerGetProfitAndLossParams,
    params: RequestParams = {},
  ) =>
    this.request<ProfitAndLossResponseDto, any>({
      path: `/api/reports/profit-and-loss`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportsControllerGetTurnover
   * @request GET:/api/reports/turnover
   */
  reportsControllerGetTurnover = (params: RequestParams = {}) =>
    this.request<TurnoverResponseDto, any>({
      path: `/api/reports/turnover`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportsControllerGetAgedReceivables
   * @request GET:/api/reports/aged-receivables
   */
  reportsControllerGetAgedReceivables = (
    query: ReportsControllerGetAgedReceivablesParams = {},
    params: RequestParams = {},
  ) =>
    this.request<AgedReceivablesResponseDto, any>({
      path: `/api/reports/aged-receivables`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportExportControllerExportReport
   * @request GET:/api/reports/export/{reportKey}
   */
  reportExportControllerExportReport = (
    { reportKey, ...query }: ReportExportControllerExportReportParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/reports/export/${reportKey}`,
      method: 'GET',
      query: query,
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportPackControllerGetEofyPack
   * @request GET:/api/reports/packs/eofy
   */
  reportPackControllerGetEofyPack = (
    query: ReportPackControllerGetEofyPackParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/reports/packs/eofy`,
      method: 'GET',
      query: query,
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportPackControllerGetReceiptBundleEstimate
   * @summary Pre-commit size estimate for a receipt bundle date range
   * @request GET:/api/reports/packs/receipts/estimate
   */
  reportPackControllerGetReceiptBundleEstimate = (
    query: ReportPackControllerGetReceiptBundleEstimateParams,
    params: RequestParams = {},
  ) =>
    this.request<ReceiptBundleEstimateResponseDto, void>({
      path: `/api/reports/packs/receipts/estimate`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportPackControllerCreateReceiptBundleJob
   * @summary Start a background job to build a receipt bundle archive
   * @request POST:/api/reports/packs/receipts
   */
  reportPackControllerCreateReceiptBundleJob = (
    data: CreateReceiptBundleJobDto,
    params: RequestParams = {},
  ) =>
    this.request<CreateReceiptBundleJobResponseDto, void>({
      path: `/api/reports/packs/receipts`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags reports
   * @name ReportPackControllerGetReceiptBundleJob
   * @summary Poll a receipt bundle export job
   * @request GET:/api/reports/packs/receipts/{jobId}
   */
  reportPackControllerGetReceiptBundleJob = (
    { jobId }: ReportPackControllerGetReceiptBundleJobParams,
    params: RequestParams = {},
  ) =>
    this.request<ExportJobStatusResponseDto, void>({
      path: `/api/reports/packs/receipts/${jobId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags tags
   * @name TagsControllerListTags
   * @request GET:/api/tags
   */
  tagsControllerListTags = (params: RequestParams = {}) =>
    this.request<TagWithUsageResponseDto[], void>({
      path: `/api/tags`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags tags
   * @name TagsControllerCreateTag
   * @request POST:/api/tags
   */
  tagsControllerCreateTag = (data: CreateTagDto, params: RequestParams = {}) =>
    this.request<TagResponseDto, void>({
      path: `/api/tags`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags tags
   * @name TagsControllerUpdateTag
   * @request PATCH:/api/tags/{id}
   */
  tagsControllerUpdateTag = (
    { id }: TagsControllerUpdateTagParams,
    data: UpdateTagDto,
    params: RequestParams = {},
  ) =>
    this.request<TagResponseDto, void>({
      path: `/api/tags/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags tags
   * @name TagsControllerDeleteTag
   * @request DELETE:/api/tags/{id}
   */
  tagsControllerDeleteTag = (
    { id }: TagsControllerDeleteTagParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/tags/${id}`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags terms-templates
   * @name TermsTemplatesControllerListTermsTemplates
   * @request GET:/api/terms-templates
   */
  termsTemplatesControllerListTermsTemplates = (params: RequestParams = {}) =>
    this.request<TermsTemplateResponseDto[], void>({
      path: `/api/terms-templates`,
      method: 'GET',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags terms-templates
   * @name TermsTemplatesControllerCreateTermsTemplate
   * @request POST:/api/terms-templates
   */
  termsTemplatesControllerCreateTermsTemplate = (
    data: CreateTermsTemplateDto,
    params: RequestParams = {},
  ) =>
    this.request<TermsTemplateResponseDto, void>({
      path: `/api/terms-templates`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags terms-templates
   * @name TermsTemplatesControllerUpdateTermsTemplate
   * @request PATCH:/api/terms-templates/{id}
   */
  termsTemplatesControllerUpdateTermsTemplate = (
    { id }: TermsTemplatesControllerUpdateTermsTemplateParams,
    data: UpdateTermsTemplateDto,
    params: RequestParams = {},
  ) =>
    this.request<TermsTemplateResponseDto, void>({
      path: `/api/terms-templates/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags terms-templates
   * @name TermsTemplatesControllerDeleteTermsTemplate
   * @request DELETE:/api/terms-templates/{id}
   */
  termsTemplatesControllerDeleteTermsTemplate = (
    { id }: TermsTemplatesControllerDeleteTermsTemplateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/terms-templates/${id}`,
      method: 'DELETE',
      ...params,
    })
  /**
   * No description
   *
   * @tags terms-templates
   * @name TermsTemplatesControllerSetDefaultTermsTemplate
   * @request PATCH:/api/terms-templates/{id}/default
   */
  termsTemplatesControllerSetDefaultTermsTemplate = (
    { id }: TermsTemplatesControllerSetDefaultTermsTemplateParams,
    params: RequestParams = {},
  ) =>
    this.request<TermsTemplateResponseDto, void>({
      path: `/api/terms-templates/${id}/default`,
      method: 'PATCH',
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags user-feedback
   * @name UserFeedbackControllerSubmitFeedback
   * @summary Submit in-app feedback
   * @request POST:/api/user-feedback
   * @secure
   */
  userFeedbackControllerSubmitFeedback = (
    data: {
      /**
       * @min 1
       * @max 5
       */
      rating: number
      ratingReason?: string
      category: 'ALPHA_TESTING' | 'BUG' | 'FEATURE_REQUEST' | 'GENERAL'
      goal?: string
      taskCompleted?: 'true' | 'false'
      primaryDetail?: string
      secondaryDetail?: string
      additionalThoughts?: string
      pageUrl: string
      /** @format binary */
      screenshot?: File
    },
    params: RequestParams = {},
  ) =>
    this.request<UserFeedbackResponseDto, void>({
      path: `/api/user-feedback`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })
}
